import React from "react";
import '../../../src/common.css';
import { useNavigate } from "react-router-dom";
import Image from "../../components/form/Image";
import { logoutUser } from "../../hooks/services/services";
const Header = ({ drawerClick, open, isSidebarHovered, hasUnread, onBellClick }) => {

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logoutUser(navigate);
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  const manKindURL = "https://mankind.iampact.co.in/";
  const isMatch = window?.location?.href?.startsWith(manKindURL);

  const showEffects = open || isSidebarHovered;

  return (
    <div className={`top-bar ${showEffects ? "sidebar-open" : ""}`}>
      {/* Backdrop for Header (Blur effect on right side) */}
      <div className="header-backdrop"></div>

      <div className="top-left">
        <div
          className={`logo-container ${showEffects ? "sidebar-open" : ""} ${isMatch ? "manKind" : ""}`}
        >
          <a className="logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <img
              src={isMatch ? "../images/Kindcare_logo.png" : "../images/Kindcare_logo.png"}
              className="img-fluid"
              alt="Mankind Logo"
              style={{
                maxHeight: '40px',
                maxWidth: '80%', // Ensure it doesn't touch edges
                objectFit: 'contain' // Prevent cutting
              }}
            />
          </a>
        </div>


      </div>
      <div className="top-right">
        {/* <div className="search">
          <Image src="../images/Search.svg" alt="Search Icon" />
          <input type="text" className="" placeholder="Search" />
        </div> */}
        {/* <div class="country circleComn">
          <div class="lang"><Image src="../images/flag.svg" /></div>
        </div> */}
        {/* <div class="country circleComn">
          <div class="lang"><Image src="../images/icon.svg" /></div>
        </div> */}
        <div className="country circleComn" style={{ cursor: "pointer", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onBellClick}>
          <div className="lang" style={{ position: "relative" }}>
            <img src="../images/bell.svg" alt="Notifications" style={{ width: "24px" }} />
            {hasUnread && (
              <span
                style={{
                  position: "absolute",
                  top: "-2px",
                  right: "-2px",
                  width: "10px",
                  height: "10px",
                  backgroundColor: "red",
                  borderRadius: "50%",
                  border: "1px solid white",
                  zIndex: 10
                }}
              ></span>
            )}
          </div>
        </div>
        {/* <div class="user-prt">
          <div class="usr"><Image src="../images/avatar.svg" /></div>
        </div> */}
        {/* <div class="user-prt">
            <a style={{cursor:'pointer'}} onClick={handleLogout}>Log Out</a>
        </div> */}
      </div>
    </div >
  );
};

export default Header;

